import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { List, Button } from "antd";
import moment from "moment";
import ExerRecordPane from "./ExerRecordPane";
import NoneData from "../common/NoneData";
export class ExerRecordQuestionCollect extends Component {
  state = {
    curPage: 1,
    questionType: -1,
    questionTypeName: "",
    checkIndex: -1,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.props.actions.fetchGetQuestionTypeList().then(res => {
      if (res.SuccessResponse) {
        this.setState({
          questionType: res.Data[0].ID,
          questionTypeName: res.Data[0].Name
        }, () => {
          this.onLoadQuestionCollect();
        })
      }
    })
  }
  onQuestionTypeClick(data) {
    this.setState({
      curPage: 1,
      questionType: data.ID,
      questionTypeName: data.Name
    }, () => {
      this.onLoadQuestionCollect();
    })
  }
  onLoadQuestionCollect() {
    this.props.actions.fetchGetCollectionList({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      BusType: 0,
      QuestionType_ID: this.state.questionType,
    })
  }
  renderItem(item, key, questionTypeName) {
    const { checkIndex } = this.state;
    return (
      <div key={key} className="question-collect-item">
        <div className="question-collect-item-content">
          <h1>
            <p>【{questionTypeName}】<span dangerouslySetInnerHTML={{ __html: item.Title }} /></p>
            <p>{moment(new Date(item.AddTime)).format("YYYY-MM-DD HH:mm:ss")}</p>
          </h1>
          <div className="btns">
            <Button className="btn" type="theme" onClick={() => {
              if (checkIndex === item.ID) {
                this.setState({
                  checkIndex: -1,
                })
              } else {
                this.setState({
                  checkIndex: item.ID,
                })
              }
            }}>{checkIndex === item.ID ? "收起题目" : "查看题目"}</Button>
          </div>
        </div>
        {
          checkIndex === item.ID && <ExerRecordPane
            {...this.props}
            item={item}
            questionTypeName={questionTypeName}
            onLoad={this.onLoadQuestionCollect.bind(this)}
          />
        }
      </div>
    )
  }
  render() {
    let { fetchGetQuestionTypeListSuccess,
      fetchGetCollectionListPending,
      fetchGetCollectionListSuccess,
      fetchGetCollectionListTotal, } = this.props.center;
    const { questionType, questionTypeName } = this.state;
    return (
      <div className="center-exer-record-question-collect">
        <div className="inner">
          {
            fetchGetQuestionTypeListSuccess && fetchGetQuestionTypeListSuccess.length > 0 &&
            <div className="question-type">
              {
                fetchGetQuestionTypeListSuccess.map(item => (
                  <div key={item.ID} onClick={this.onQuestionTypeClick.bind(this, item)} className={questionType === item.ID ? "question-type-item-active" : "question-type-item"}>
                    {item.Name}
                  </div>
                ))
              }
            </div>
          }
          {
            fetchGetCollectionListSuccess && fetchGetCollectionListSuccess.length > 0 &&
            <div className="question-collect-list">
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState({
                      curPage: page,
                    }, () => {
                      this.onLoadQuestionCollect();
                    })
                  },
                  current: this.state.curPage,
                  total: fetchGetCollectionListTotal,
                  pageSize: 5,
                }}
                loading={fetchGetCollectionListPending}
                dataSource={fetchGetCollectionListSuccess}
                renderItem={(item, key) => this.renderItem(item, key, questionTypeName)}
              />
            </div>
          }
          {
            fetchGetCollectionListSuccess && fetchGetCollectionListSuccess.length === 0 &&
            <div className="noneData">
              <NoneData type={2} />
            </div>
          }
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerRecordQuestionCollect);



// WEBPACK FOOTER //
// ./src/features/center/ExerRecordQuestionCollect.js